'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { assistChipLabelStyles } from './styles/assist-chip-label.styles';
import type { AssistChipLabelPropsInterface } from './types/assist-chip-label.types';

/**
 * @since 10.0.0
 */
export const AssistChipLabel = forwardRef<HTMLSpanElement, AssistChipLabelPropsInterface>(
  (props, forwardedRef) => {
    const { children, className, css: cssProp, truncate = true, ...rest } = props;

    const styles = css({ truncate }, assistChipLabelStyles, cssProp);

    return (
      <span
        ref={forwardedRef}
        data-c11n-component="AssistChip.Label"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_assist-chip__label', styles, className)}
        {...rest}
      >
        {children}
      </span>
    );
  },
);

AssistChipLabel.displayName = 'AssistChip.Label';
